import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
// Images
import defaultImage from "../../Images/profile.png"

import { apiService } from "../../Axios/apiService"; 

export default function ViewUser() {
  const params = useParams();
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState();
    const [error, setError] = useState();

    console.log("view user page")

    // Load user
    useEffect(() => {
        console.log("loading user...",params.id);

        apiService("get", `users/${params.id}`, null,
            (response) => {
                console.log("Users:", response);
                setCurrentUser(response);
                setLoading(false);
            },
            (error) => {
                setLoading(false);
                if (error.response.status == "404")
                    setError(error.response.data);
                if (error.response.status == "403")
                    setError("You dont have permission to view this user");
                else
                    setError(error.response.data);
            }
        )



       
           
          
    }, [])

    
    
    return (
        <div className="page">
            {error && (
            <div className="row">
                <div className="col-8">
                        <h3>Failed To Load User</h3>
                        <p>{error}</p>
                </div>
            </div>) }
            {loading && (<Spinner />)}
            {!loading && currentUser && (
                <div className="row">
                    <div className="col-8">

                        <div className="row">
                            <div className="col-12">
                                <h1>
                                    {currentUser.firstName} {currentUser.lastName}
                                    <Link to={`/Users/Edit/${currentUser.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>
                                </h1>
                            </div>
                        </div>


                        

                        {/* Account Details Header */}
                        <div className="row">
                            <div className="col-12">
                                <h3>Account Details</h3>
                            </div>
                        </div>
                
                        {/* Role */}
                        <div className="row">
                            <div className="col-4">
                                Role
                            </div>
                            <div className="col-8">
                                    {currentUser.role}
                            </div>
                        </div>

                        {/* Contact Details Header */}
                        <div className="row">
                            <div className="col-12">
                                <h3 style={{ marginTop: 20 }}>Contact Details</h3>
                            </div>
                        </div>

                        {/* Address */}
                        <div className="row">
                            <div className="col-4">
                                Address
                            </div>
                                <div className="col-8" style={{ whiteSpace: "pre-line"}}>
                                {currentUser.address}
                            </div>
                        </div>

                        {/* Postcode */}
                        <div className="row">
                            <div className="col-4">
                                Postcode
                            </div>
                            <div className="col-8">
                                {currentUser.postcode}
                            </div>
                        </div>

                        {/* Telephone */}
                        <div className="row" style={{marginTop: 10}}>
                            <div className="col-4">
                                Telephone
                            </div>
                            <div className="col-8">
                                {currentUser.telephone}
                            </div>
                        </div>

                        {/* Email */}
                        <div className="row">
                            <div className="col-4">
                                Email
                            </div>
                            <div className="col-8">
                                {currentUser.email}
                            </div>
                        </div>
                    </div>
                        <div className="col-4 text-end">
                        <img src={currentUser.profileImage ? currentUser.profileImage : defaultImage} style={{ width: "100%", borderRadius: 10 }} />
                    </div>
                </div>

            )}
        </div>
  )
}
